// 公告发布
<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info">
      <el-form-item prop="sceneryName">
        <el-input v-model="info.title" placeholder="请输入公告标题" clearable></el-input>
      </el-form-item>
      <el-form-item prop="isNetRed">
        <el-select v-model="info.pubStatus" placeholder="请选择发布状态" clearable>
          <el-option label="未发布" value="0"></el-option>
          <el-option label="已发布" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" @click='onAdd' type="primary" icon='el-icon-plus' v-if="$ButtonShow('NOT_ADD_01')">添加公告</el-button>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="公告标题" show-overflow-tooltip prop="title"></el-table-column>
      <el-table-column label="发布日期" show-overflow-tooltip prop="pubTime"></el-table-column>
      <el-table-column label="公告状态" show-overflow-tooltip prop="pubStatus">
        <template v-slot="{ row }">
          {{ row.pubStatus === '1' ? '已发布' : '未发布' }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" show-overflow-tooltip prop="ctime"></el-table-column>
      <el-table-column label="操作" width="150px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" v-if="row.pubStatus === '0' && $ButtonShow('NOT_EDT_01')" @click="onPub(row.noticeId)">发布</el-button>
          <el-button type="text" v-if="row.pubStatus === '0' && $ButtonShow('NOT_EDT_01')" @click="onUpdate(row.noticeId)">编辑</el-button>
          <el-button type="text" @click="onDelete(row.noticeId)" v-if="$ButtonShow('NOT_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Scenicspot',
  mixins: [keepAlive],
  data() {
    return {
      info: {
        pubStatus: '',
        title: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: []
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectNoticeByPage, {
        ...this.info,
        page: this.page,
        size: this.size
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/notice/add')
    },
    onPub(id) {
      this.$axios.post(this.$apis.tourist.sendNotice, {
        noticeId: id
      }).then(() => {
        this.loadData()
        this.$message({
          message: '发布成功',
          type: 'success'
        })
      })
    },
    onUpdate(id) {
      this.$router.push({
        name: 'NoticeUpdate',
        params: { id }
      })
    },
    onDelete(id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteNotice, {
          noticeId: id
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
